import { assetThumbnailUrl, assetUrl, assetViewUrl } from '@/utils/assetUrls';
import type { ResolvedAssets, UploadedAsset } from '@/types/api/assets';
import type { ToolConfigOutputExample } from '@/types/tool-config.types';

/** Outputs that may carry frozen examples — run-data or the builder's toolConfig. */
type OutputsWithExamples = ReadonlyArray<{
  nodeId: string;
  examples?: ToolConfigOutputExample[];
}>;

/** Converts inspect / tool-config examples into the asset shape used by the shared read-only gallery. */
export function toolOutputExamples(outputs: OutputsWithExamples, resolvedAssets: ResolvedAssets): UploadedAsset[] {
  const examples: UploadedAsset[] = [];
  for (const { nodeId, examples: outputExamples } of outputs) {
    outputExamples?.forEach((example, index) => {
      if (example.kind === 'text') {
        examples.push({ id: `tool-example-${nodeId}-${index}`, type: 'text', value: example.text });
        return;
      }

      const url = assetUrl(example.file, resolvedAssets);
      if (!url) {
        return;
      }
      examples.push({
        id: `tool-example-${nodeId}-${index}`,
        type: example.type,
        blobstore: example.file.blobstore,
        width: example.file.width,
        height: example.file.height,
        mime: example.file.mime,
        url,
        viewUrl: assetViewUrl(example.file, resolvedAssets) ?? url,
        thumbnailUrl:
          assetThumbnailUrl({ ...example.file, type: example.type }, resolvedAssets, { type: example.type }) ??
          (example.type === 'video' ? url : ''),
        publicId: '',
        visualId: '',
      });
    });
  }
  return examples;
}
